<template>
  <TransitionRoot appear :show="showModal" as="template">
    <Dialog as="div" :open="showModal" @close="closeModal">
      <div class="fixed inset-0 z-30 overflow-y-auto">
        <div class="min-h-screen px-4 text-center flex">
          <DialogOverlay class="fixed inset-0 bg-black opacity-30" />

          <TransitionChild
            as="template"
            enter="duration-300 ease-out"
            enter-from="opacity-0 scale-95"
            enter-to="opacity-100 scale-100"
            leave="duration-200 ease-in"
            leave-from="opacity-100 scale-100"
            leave-to="opacity-0 scale-95"
          >
            <div
              class="inline-block w-full md:w-1/3 md:my-5 max-w-screen-md py-3 px-3 m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
            >
              <div class="flex flex-row pb-4">
                <div class="flex-1"></div>
                <div class="flex-4 cursor-pointer" @click="closeModal">
                  <img class="w-3" src="@/assets/icons/close.svg" ref="close" />
                </div>
              </div>

              <div class="pb-5 px-5 md:pb-8 md:px-10">
                <h2 class="text-xl py-2">Select Field to Add</h2>

                <p class="py-1">Select the field to add to:</p>
                <p class="font-semibold">{{ sectionLabel }}</p>

                <div
                  v-for="field in fieldDefaults.filter(
                    (f) => f.display_in_builder && f.field_id !== 'unit_field'
                  )"
                  :key="`field-${field.field_id}`"
                  class="py-2"
                >
                  <AddFieldOption
                    :field="field"
                    @click="addField(field.field_id)"
                    v-if="
                      field.field_id !== 'agent' ||
                      (getCurrentUser.landlord.agent_field_enabled &&
                        getCurrentUser.landlord.in_company)
                    "
                  />
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
<script>
import fieldDefaults from "@/constants/fieldDefaults"

import { mapGetters } from "vuex"

import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import AddFieldOption from "./AddFieldOption.vue"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    sectionLabel: {
      type: String
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    AddFieldOption
  },
  computed: {
    ...mapGetters(["getCurrentUser"])
  },
  mounted() {
    this.fieldDefaults = [...fieldDefaults]
  },
  data() {
    return {
      fieldDefaults: []
    }
  },
  methods: {
    closeModal() {
      this.$emit("close")
    },
    addField(type) {
      this.$emit("close", type)
    }
  }
}
</script>
<style scoped></style>
